import { heroImages, reversalItems } from "@/mocks/siteData";

export default function Reversal() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="reversal" className="scroll-mt-20 border-y border-background-200 bg-background-100">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 px-4 py-16 md:px-6 md:py-24 lg:grid-cols-[1fr_1.25fr]">
        <div className="relative lg:sticky lg:top-24 lg:self-start">
          <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
            <img
              src={heroImages.reversalBig}
              alt="反转证据天平主题插画：两叠卷宗在证据秤两端摇摆"
              className="h-[360px] w-full object-cover object-top md:h-[460px]"
            />
          </div>
          <div className="mt-4 flex items-center justify-between rounded-xl border border-primary-200 bg-primary-100/60 px-5 py-4">
            <div>
              <p className="font-heading text-lg font-black text-primary-700">真相反转中</p>
              <p className="mt-1 text-xs text-primary-800/80">
                本事件已出现 <strong>2 幕反转</strong>，<strong>1 幕已定论</strong>，仍有反转点未落定。
              </p>
            </div>
            <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-refund-2-line text-xl" />
            </span>
          </div>
        </div>

        <div>
          <div className="flex items-center gap-3">
            <span className="inline-flex h-px w-8 bg-primary-500" aria-hidden="true" />
            <span className="kicker text-[11px] font-bold uppercase text-primary-600">Plot Reversals</span>
          </div>
          <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[34px]">
            反转精选 · 别急着下结论
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-[15px]">
            同一条事件，早上的"实锤"到晚上可能就被推翻。这里按"反转幕次"把每一轮前后说法对照归档，帮你厘清到底哪一步才是关键转折。
          </p>

          <ol className="mt-8 space-y-5">
            {reversalItems.map((item, idx) => (
              <li key={item.id}>
                <article className="rounded-2xl border border-background-200 bg-background-50 p-5 transition-shadow hover:shadow-lift md:p-6">
                  <div className="flex flex-wrap items-center justify-between gap-2">
                    <div className="flex items-center gap-3">
                      <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-foreground-950 font-heading text-sm font-black text-background-50">
                        {String(idx + 1).padStart(2, "0")}
                      </span>
                      <span
                        className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold ${
                          item.stage.includes("反转")
                            ? "bg-primary-100 text-primary-700"
                            : "bg-secondary-100 text-secondary-800"
                        }`}
                      >
                        <i className="ri-refund-2-fill" />
                        {item.stage}
                      </span>
                    </div>
                    <i className="ri-download-2-line rotate-90 text-foreground-300" aria-hidden="true" />
                  </div>

                  <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950 md:text-xl">{item.title}</h3>

                  <div className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-2">
                    <div className="rounded-lg border border-background-200 bg-background-100 p-4">
                      <p className="flex items-center gap-2 text-xs font-bold text-foreground-700">
                        <i className="ri-arrow-left-circle-line" />
                        反转前 · 当时怎么说
                      </p>
                      <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">{item.before}</p>
                    </div>
                    <div className="rounded-lg border border-background-200 bg-background-100 p-4">
                      <p className="flex items-center gap-2 text-xs font-bold text-primary-600">
                        <i className="ri-arrow-right-circle-line" />
                        反转后 · 现在看
                      </p>
                      <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">{item.after}</p>
                    </div>
                  </div>

                  <div className="mt-3 rounded-lg border-l-4 border-primary-500 bg-primary-100/50 px-4 py-3">
                    <p className="text-[13px] font-semibold leading-relaxed text-primary-900">
                      <strong>小编结论：</strong>
                      {item.verdict}
                    </p>
                  </div>
                </article>
              </li>
            ))}
          </ol>

          <button
            type="button"
            onClick={() => scrollTo("timeline")}
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            回到完整时间线再看一遍
            <i className="ri-arrow-down-line" />
          </button>
        </div>
      </div>
    </section>
  );
}